import React,{useState} from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  CssBaseline,
  Box,
  Container,
  Grid, 
  Chip,
  Paper,
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import moment from 'moment-timezone';

import Copyright from '../../components/Copyright';
import TopBar from '../../components/TopBar';
import Title from '../../components/Title';
import DrawerMenu from '../../components/DrawerMenu';
import useStyles from '../../useStyles';
import RadarChartStores from './components/RadarChartStores';
import MultipleChartsHist from './components/MultipleChartsHist';
import PizzaChartProductHist from './components/PizzaChartProductHist';
import ConvertionAttendanceScatter from './components/ConvertionAttendanceScatter';

export default function HistData(props) {
  const classes = useStyles();
  const [dateBegin,setDateBegin] = useState(moment(new Date()).subtract(1,'weeks'));
  const [dateEnd,setDateEnd] = useState(moment(new Date()));

  var stores = JSON.parse(sessionStorage.getItem('stores'));
  stores = stores.map((el)=>({
    "store_id": el.id,
    "store_name": el.store_name
  }))
  var [storesDisplayed, setStoresDisplayed] = useState(stores)
  function StoreChip(props){
    var store = props.store;

    function isStoreVisible(store_id){
      if(storesDisplayed.find(x=> x.store_id === store_id)){
        return true;
      }else{
        return false;
      }
    }

    const [visible,setVisible] = useState(isStoreVisible(store.store_id));
    return(
      <Chip
        label={store.store_name}
        clickable
        color='primary'
        icon={visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
        size="small"
        onClick={()=>{
          if(isStoreVisible(store.store_id)){
            setVisible(false);
            let tempstores = storesDisplayed.filter(x=>x.store_id !== store.store_id);
            setStoresDisplayed(tempstores);
            // console.log('removed:',tempstores)
          }else{
            let tempstores = storesDisplayed.concat(store);
            setStoresDisplayed(tempstores);
            setVisible(true);
            // console.log('added:',tempstores)
          }          
        }}
      />  
    )
  }

  
  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBar hideStore={true} />
      <DrawerMenu/>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3} justifyContent={"flex-start"} direction="row">
            <Grid item xs={12} md={12} lg={12}>
              <Title><BarChartIcon /> Dados históricos</Title>
            </Grid> 
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={classes.paper}>
              <Grid container spacing={3} justifyContent="space-between" direction="row">
                  <Grid item xs={6} md={6} lg={6}>
                    <Grid container spacing={3} justifyContent="flex-start" direction="row">
                      {stores.map((el)=>(
                        <Grid item xs key={el.store_id}>
                          <StoreChip store={el}/>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <LocalizationProvider dateAdapter={DateFnsUtils}>
                      <Grid container justifyContent="space-around">
                          <DatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            label="Data inicio"
                            inputFormat="dd/MM/yyyy" 
                            value={dateBegin}
                            onChange={(date)=>{setDateBegin(moment(date))}}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            renderInput={(props) => <TextField {...props} variant="standard"/>}
                          />
                          <DatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            label="Data fim"
                            inputFormat="dd/MM/yyyy" 
                            value={dateEnd}
                            onChange={(date)=>{setDateEnd(moment(date))}}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            renderInput={(props) => <TextField {...props} variant="standard"/>}
                          />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>
                </Grid>    
              </Paper>
            </Grid>
            {
              (dateBegin && dateEnd)
              ?
              <>
                <RadarChartStores storesDisplayed={storesDisplayed} date={[dateBegin.format('YYYY-MM-DD'),dateEnd.format('YYYY-MM-DD')]}/>
                <ConvertionAttendanceScatter storesDisplayed={storesDisplayed} date={[dateBegin.format('YYYY-MM-DD'),dateEnd.format('YYYY-MM-DD')]}/>
                <MultipleChartsHist storesDisplayed={storesDisplayed} date={[dateBegin.format('YYYY-MM-DD'),dateEnd.format('YYYY-MM-DD')]}/>
                <PizzaChartProductHist storesDisplayed={storesDisplayed} date={[dateBegin.format('YYYY-MM-DD'),dateEnd.format('YYYY-MM-DD')]}/>
              </>
              :
              null
            }
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}
